/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Company} from '../../core/_models'
import moment from 'moment'

type Props = {
  user: Company
}

const CompanyJoinedCell: FC<Props> = ({user}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    <div className='d-flex flex-column'>{moment(user.createdAt).format('MM-DD-YYYY')}</div>
  </div>
)

export {CompanyJoinedCell}
